import { BsCheck2Circle } from 'react-icons/bs';
import './FinalStepBookingForm.css';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

function FinalStepBookingForm({ bookingID }) {
    const phone = useSelector(
        (state) => state.miniBookingWidget?.data?.propertyPhone
    );
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    return (
        <div className="ab-final-step-wrapper">
            <BsCheck2Circle size={100} />
            <p className="ab-book-confrm-text">Your Booking is Confirmed!</p>
            <div className="ab-mg-20 ab-book-confrm-main-text">
                {Lang?.yourBookingIsConfirmed}.
            </div>
            <div className="ab-book-confrm-main-text">
                {Lang?.your}{' '}
                <span style={{ fontWeight: '800' }}>Purchase No.</span>{' '}
                {Lang?.isText} {bookingID}
            </div>
            <div className="ab-book-confrm-main-text">
                {Lang?.inTheNextMinutesYoullReceiveAnEmail}
            </div>
            <div className="ab-book-confrm-main-text">
                {Lang?.withBookingDetails}.
            </div>
            <div className="ab-book-confrm-main-text">
                {Lang?.pleasePresentThisConfirmationAtCheckIn}.
            </div>
            <div className="ab-book-confirm-need-help-text ab-book-confrm-text">
                {Lang?.needHelpWithYourReservation}?
            </div>
            <div className="ab-book-confrm-main-text">
                <span style={{ fontWeight: '800', paddingRight: '10px' }}>
                    {Lang?.contactTheProperty}
                </span>{' '}
                {Lang?.phone}: {phone}
            </div>
        </div>
    );
}
FinalStepBookingForm.propTypes = {
    bookingID: PropTypes.string,
};

export default FinalStepBookingForm;
